/**
 * Normalize a title for URL usage
 * Removes accents, special characters, and replaces spaces with underscores
 */
export function normalizeTitleForUrl(str: string): string {
  if (!str) return '';
  
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove accents
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '') // Remove special characters
    .trim()
    .replace(/\s+/g, '_'); // Replace spaces with underscores
}

/**
 * Generate an SEO-friendly URL for a recipe
 * Format: recette_{normalized_title}_{id}
 */
export function generateRecipeSeoUrl(title: string, id: string): string {
  const normalizedTitle = normalizeTitleForUrl(title);
  
  // Ensure the title is not too long (for readability and potential URL length constraints)
  const truncatedTitle = normalizedTitle.substring(0, 50);
  
  return `recette_${truncatedTitle}_${id}`;
}

/**
 * Extracts the recipe ID from an SEO URL
 * Example: recette_tarte_aux_pommes_abc123 -> abc123
 */
export function extractRecipeIdFromSeoUrl(seoUrl: string): string | null {
  const match = seoUrl.match(/recette_.*_([a-zA-Z0-9]+)$/);
  return match ? match[1] : null;
}

